import { Component, Input } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { IModalLuminaryModel } from '@types-custom/models/ui/modal-luminary-model';

@Component({
  selector: 'citizen-modal-luminary-maintenance',
  templateUrl: './modal-luminary-maintenance.component.html',
  styleUrls: ['./modal-luminary-maintenance.component.scss'],
})
export class ModalLuminaryMaintenanceComponent {
  @Input() properties: IModalLuminaryModel | undefined;
  Icon = Icon;
}
